@use "sass:map";
@use "@/common/styles/defaults/ga";

$header-grid-gap: 0.375rem;
$header-padding-x-sm: 0.375rem;

.header {
    border-block-end: ga.$border;
    position: sticky;
    top: 0;
    background-color: ga.$white;
    z-index: ga.$zindex-fixed;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    --ga-navigation-header-height: #{ga.$header-height-sm};
}

.header__container {
    height: var(--ga-navigation-header-height);
    display: grid;
    grid-template:
        "navigation logo controls" 1fr
        / #{ga.$mobile-navigation-size} 1fr max-content;
    grid-gap: $header-grid-gap;
}

.header__container > * {
    align-self: center;
}

.header__navigation {
    z-index: ga.$zindex-fixed;
    grid-area: navigation;
}

.header__logo {
    grid-area: logo;
    padding-left: 0.25rem; // Added to the grid gap to match the 10px;
    z-index: ga.$zindex-fixed;
}


.header__logo-img {
    display: block;
}

.header__controls {
    grid-area: controls;
    display: flex;
    gap: .5rem;
}

.header__cta {
    display: none;
}

@include ga.media-breakpoint-up(md) {
    .header {
        --ga-navigation-header-height: #{ga.$header-height-md};
    }
    .header__controls:has([data-logged-out]) {
        .header__cta {
            display: block;
        }
    }
}

// Horizontal layout - triggered by CSS variable set in media query (with lg fallback based on @media)
@mixin header-horizontal-layout {
    .header__container {
        --ga-navigation-header-height: #{ga.$header-height};
        grid-template:
        "logo navigation controls" 1fr
        / max-content 1fr max-content;
    }

    .header__logo {
        padding-right: 2rem;
    }
}

@container style(--ga-nav-horizontal: true) {
    @include header-horizontal-layout;
}

@include ga.media-breakpoint-up(lg) {
    @include header-horizontal-layout;
}
